/*
 * AccessDenied
 *
 * Component displayed when user doesn't have admin access
 */

import { Header } from '../features/header/Header';
import { Footer } from '../features/footer/Footer';
import { Container, Card, CardBody } from 'reactstrap';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import messages from '../pages/MappingAdminPage/messages';

const StyledContainer = styled(Container)`
  margin-top: 2rem;
  margin-bottom: 2rem;
`;

const AccessDenied = () => (
  <>
    <Header />
    <StyledContainer>
      <Card>
        <CardBody>
          <h3>
            <FormattedMessage {...messages.accessDeniedTitle} />
          </h3>
          <p>
            <FormattedMessage {...messages.accessDeniedMessage} />
          </p>
        </CardBody>
      </Card>
    </StyledContainer>
    <Footer />
  </>
);

export default AccessDenied;
